import { motion } from "framer-motion";
import { FOCUS, IMAGES } from "../../data";
import { Reveal, Kicker } from "./Reveal";

export default function Investment() {
  return (
    <section id="investment-focus-section" data-testid="investment-focus-section" className="py-24 lg:py-36 bg-sand2">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <Reveal><Kicker>Where We Invest</Kicker></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-serif text-4xl sm:text-5xl text-ink tracking-tight leading-[1.08]">Spheres of conscious enterprise</h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {FOCUS.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.08} className={`col-span-1 ${f.span}`}>
              <motion.div data-testid="investment-bento-card" whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 280, damping: 22 }}
                className="group relative h-full min-h-[300px] rounded-3xl overflow-hidden border border-borderln">
                <img src={IMAGES[f.img]} alt={f.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/40 to-ink/10" />
                <div className="relative h-full flex flex-col justify-end p-7 sm:p-9">
                  <span className="text-xs uppercase tracking-[0.24em] text-brass font-semibold mb-3">0{i + 1}</span>
                  <h3 className="font-serif text-2xl sm:text-3xl text-sand">{f.title}</h3>
                  <p className="mt-2.5 text-sand/75 max-w-md leading-relaxed">{f.desc}</p>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
